// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledTableRow = styled("tr").attrs((props) => ({
	...props,
	scope: "row",
}))`
	text-align: left;
	background-color: rgba(0, 0, 0, 0);
	&:hover {
		background-color: ${({ theme: { colors } }) => colors.itemsHover};
		& .withBoxShadow {
			box-shadow: ${({ theme: { isDarkMode, utils } }) =>
				isDarkMode
					? utils.createBoxShadow(["cardDark"])
					: utils.createBoxShadow(["cardLight"])};
		}
	}

	&[data-rowActive="true"] {
		background-color: ${({ theme: { colors } }) => colors.itemsHover};
		& .withBoxShadow {
			box-shadow: ${({ theme: { isDarkMode, utils } }) =>
				isDarkMode
					? utils.createBoxShadow(["cardDark"])
					: utils.createBoxShadow(["cardLight"])};
		}
	}

	${({ moderate }) =>
		moderate &&
		css`
			background-color: ${({ theme: { colors } }) =>
				colors.buttonsDefaultGrey};
		`}
`;

// #####################################################
